import { Component, OnInit, Input } from '@angular/core';
import { Result } from '../../objects/result';
import { EventInfo } from '../../objects/EventInfo';
import { UtilityService } from '../../services/utility.service';

@Component({
  selector: 's18-player-scorecard',
  templateUrl: './player-scorecard.component.html',
  styleUrls: ['./player-scorecard.component.scss']
})
export class PlayerScorecardComponent implements OnInit {
  
  @Input() eventResult: Result;
  @Input() eventInfo: EventInfo;

  holesIndex = Array(9).fill(0).map((x,i) => i);

  config = {
    number_of_rounds: 1,
    holes_played_per_round: [18],
    total_holes: 18
  }; 

  constructor(
    private utilityService: UtilityService
  ) { }

  ngOnInit() {
    if ( this.eventResult && this.eventResult.rounds_holes_played){
      this.config.number_of_rounds = this.eventResult.rounds_holes_played.split(',').length;
      this.config.holes_played_per_round = this.eventResult.rounds_holes_played.split(',').map(x => +x);
      this.config.total_holes = 0;
      for (var i in this.config.holes_played_per_round) {
        this.config.total_holes += this.config.holes_played_per_round[i]
      }
    }
  }

}
